/* src/app/component/canvas-badge/canvas-badge.component.css */
:host-context(app-canvas-badge) .badge {
  height: 100%;
  width: auto;
}
:host-context(app-canvas-badge) .preview {
  height: 100%;
  width: auto;
  margin: auto;
  max-height: 72vh;
}
/*# sourceMappingURL=canvas-badge.component.css.map */
